import React from 'react'
import {
    DashboardOutlined,
    UserOutlined,
    ShopOutlined,
    ShoppingOutlined,
    FileTextOutlined,
    SettingOutlined,
    TeamOutlined,
    BellOutlined,
    BarChartOutlined,
    SafetyOutlined,
    GiftOutlined,
    CustomerServiceOutlined,
    AppstoreOutlined,
    CloudServerOutlined,
    RocketOutlined,
    PercentageOutlined,
    WalletOutlined,
    CreditCardOutlined,
    BankOutlined,
    FileProtectOutlined
} from '@ant-design/icons'

export interface SidebarSubItem {
    key: string;
    label: string;
    path: string;
    permission?: string | null;
}

export interface SidebarItem {
    key: string;
    icon?: React.ComponentType<any>;
    label: string;
    path?: string;
    permission?: string | null;
    requireSuperAdmin?: boolean;
    children?: SidebarSubItem[];
}

export const sidebarConfig: SidebarItem[] = [
    {
        key: 'dashboard',
        icon: DashboardOutlined,
        label: 'Dashboard',
        path: '/dashboard',
        permission: null,
    },
    {
        key: 'admins',
        icon: SafetyOutlined,
        label: 'Admin Users',
        path: '/admins',
        permission: null,
        requireSuperAdmin: true,
    },
    {
        key: 'users',
        icon: UserOutlined,
        label: 'Customers',
        path: '/users',
        permission: 'users',
    },
    {
        key: 'merchants',
        icon: ShopOutlined,
        label: 'Merchants',
        path: '/merchants',
        permission: 'merchants',
    },
    {
        key: 'trials',
        icon: GiftOutlined,
        label: 'Trial Management',
        path: '/trials',
        permission: 'trials',
    },
    {
        key: 'commissions',
        icon: PercentageOutlined,
        label: 'Commission Rules',
        path: '/commissions',
        permission: 'merchants',
    },
    {
        key: 'products-menu',
        icon: AppstoreOutlined,
        label: 'Products',
        permission: 'products',
        children: [
            { key: 'products-list', label: 'All Products', path: '/products' },
            { key: 'attributes', label: 'Attributes', path: '/products/attributes' },
            { key: 'brands', label: 'Brands', path: '/brands' },
            { key: 'categories', label: 'Categories', path: '/categories' },
            { key: 'units', label: 'Unit Master', path: '/units', permission: 'units' }
        ]
    },
    {
        key: 'rfqs',
        icon: ShoppingOutlined,
        label: 'RFQs & Bids',
        path: '/rfqs',
        permission: 'rfqs',
    },
    {
        key: 'orders',
        icon: ShoppingOutlined,
        label: 'Orders',
        path: '/orders',
        permission: 'orders',
    },
    {
        key: 'payments',
        icon: CreditCardOutlined,
        label: 'Payments',
        path: '/payments',
        permission: 'payments',
    },
    {
        key: 'settlements',
        icon: WalletOutlined,
        label: 'Settlements',
        path: '/settlements',
        permission: 'settlements',
    },
    {
        key: 'financials',
        icon: BankOutlined,
        label: 'Financials',
        permission: 'financials',
        children: [
            { key: 'financials-overview', label: 'Overview', path: '/financials/overview' },
            { key: 'financials-adjustments', label: 'Adjustments', path: '/financials/adjustments' },
            { key: 'financials-ledger', label: 'Merchant Ledger', path: '/financials/ledger' }
        ]
    },
    {
        key: 'disputes',
        icon: CustomerServiceOutlined,
        label: 'Disputes',
        path: '/disputes',
        permission: 'disputes',
    },
    {
        key: 'subscriptions-menu',
        icon: FileTextOutlined,
        label: 'Subscriptions',
        children: [
            { key: 'subscriptions-dashboard', label: 'Dashboard', path: '/subscriptions/dashboard', permission: 'subscription_invoices.view' }
        ]
    },
    {
        key: 'invoices-menu',
        icon: FileTextOutlined,
        label: 'Invoices',
        children: [
            { key: 'marketplace-invoices', label: 'Marketplace Invoices', path: '/marketplace-invoices', permission: 'marketplace_invoices' },
            { key: 'subscription-invoices', label: 'Subscription Invoices', path: '/subscription-invoices', permission: 'subscription_invoices' }
        ]
    },
    {
        key: 'referrals',
        icon: GiftOutlined,
        label: 'Referrals',
        permission: 'merchants',
        children: [
            { key: 'campaigns', label: 'Campaigns', path: '/campaigns' },
            { key: 'referral-analytics', label: 'Analytics', path: '/referral-analytics' }
        ]
    },
    {
        key: 'notifications-menu',
        icon: BellOutlined,
        label: 'Notifications',
        permission: 'notifications',
        children: [
            { key: 'notifications-logs', label: 'Logs', path: '/notifications' },
            { key: 'notifications-templates', label: 'Templates', path: '/notification-templates' }
        ]
    },
    {
        key: 'analytics',
        icon: BarChartOutlined,
        label: 'Analytics',
        path: '/analytics',
        permission: 'analytics',
    },
    {
        key: 'roles',
        icon: TeamOutlined,
        label: 'Roles & Permissions',
        path: '/roles',
        permission: 'roles',
    },
    {
        key: 'promotions',
        icon: RocketOutlined,
        label: 'Sponsored Ads',
        path: '/promotions',
        permission: 'promotions',
    },
    {
        key: 'audit-logs',
        icon: FileProtectOutlined,
        label: 'Audit Logs',
        path: '/audit-logs',
        permission: 'audit.view',
    },
    {
        key: 'settings',
        icon: SettingOutlined,
        label: 'Settings',
        path: '/settings',
        permission: 'settings.manage',
    }
];
